import ApiService from './ApiService';

export default class AuthApi extends ApiService {
    login(payload) {
        return this.post('end/login', payload);
    }

    logout() {
        return this.post('end/logout');
    }

    getProfile() {
        return this.get('end/profile');
    }

    signUp(payload) {
        return this.post('end/register', payload);
    }

    getOtp(payload) {
        return this.post('end/getCode', payload);
    }

    verifyOtp(payload) {
        return this.post('end/verifyOTP', payload);
    }

    generateResistration(payload) {
        return this.post('end/generate-registration-options', payload);
    }

    generateAuthentication(payload) {
        return this.post('end/generate-authentication-options', payload);
    }

    getInfoX(payload) {
        return this.get('end/getInfoXByCode', payload);
    }

    getMyInfo() {
        return this.get('end/user');
    }

    updateMyInfo(payload) {
        return this.put('end/user', payload);
    }
}
